export default class DtoTankEquipments {
    constructor(obj) {
        this.idStation = obj.idStation // Long,
        this.typeDetectionLevel = obj.typeDetectionLevel // Option[Long],
        this.distributionFlowMeasurement = obj.distributionFlowMeasurement // Option[Long],
        this.alimentationFlowMeasurement = obj.alimentationFlowMeasurement // Option[Long]
    }
}